<template>
  <div class="Main">
    <div class="loading" v-if="isLoading">Loading&#8230;</div>
    <app-toast />
    <app-good/>
    <div id="wrapper">
      <div class="fixed-bg2"></div>
      <app-header-member  v-if="isMember" />
      <!-- <app-sidebar/> -->
      <!-- <app-header /> -->
      <div class="row p-0 m-0 main_">
        <!-- <app-banner style="border-radius: 20px !important;" class="w-100" v-b-modal.modal-news-agent /> -->
        <app-header class="" v-if="!isMember"/>
        <app-login v-if="!isMember" />
        <app-register v-if="!isMember && (BYPASS_OTP == 0)" />
        <app-register-no-otp v-if="!isMember && (BYPASS_OTP == 1)" />
        <!-- <app-register_success /> -->
        <router-view :class="[this.$route.meta.isSubLayout ? 'col-md-8 col-sm-12 p-1': 'col-12']" ></router-view>
      </div>
      <app-footer />
    </div>
    <app-box-vip v-bind:vip_level="getVip" v-bind:balance="getCreditTotal" v-bind:username="getUser" v-bind:credit_total="getCreditTotal" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import Sidebar from '@/components/Sidebar'
// import subLayout from '@/components/subLayout'
import HeaderMember from '@/components/HeaderMember'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Toast from '@/components/toastalerts/Toast'
import Good from '@/components/toastalerts/Good'
// import banner from '@/components/banner'
import login from '@/components/login'
// import register_success from '@/components/register_success'

// VUE_APP_EXT_NAME
import register from '@/components/register3'
// import register from '@/components/register'
import register_no_otp from '@/components/registerNoOtp'
import BoxVip from '@/components/box_vip'

const nonFooterPath = ['register-verify', 'register-form', 'register-success']

export default {
  name: 'Main',
  data () {
    return {
      BYPASS_OTP: process.env.VUE_APP_BYPASS_OTP
    }
  },
  components: {
    'app-box-vip': BoxVip,
    // 'app-sidebar': Sidebar,
    'app-header-member': HeaderMember,
    'app-header': Header,
    'app-footer': Footer,
    'app-toast': Toast,
    'app-good': Good,
    // 'app-banner': banner,
    // 'app-header': Header,
    'app-login': login,
    'app-register': register,
    'app-register-no-otp': register_no_otp
    // 'app-register_success': register_success
  },
  created () {
    this.changeFooter()
  },
  updated () {
    this.changeFooter()
  },
  computed: {
    ...mapState({
      isMember: (state) => state.authModule.isMember,
      isLoading: (state) => state.homeModule.isLoading
    }),
    ...mapGetters([
      'getAffiliateLink',
      'getCurrentIncome',
      'getTotalClick',
      'getTotalIncome',
      'getDownline',
      'getTotalBet',
      'getNews',
      'getAgentNews'
    ]),
    getBalance () {
      return this.$store.getters.getBalance
    },
    getUser () {
      return this.$store.getters.getUsername
    },
    getCreditTotal () {
      return this.$store.getters.getCreditTotal
    },
    getVip () {
      return this.$store.getters.getVip
    },
    getIsVip () {
      return this.$store.getters.getIsVip
    }
  },
  methods: {
    changeFooter () {
      const pathName = window.location.pathname
      nonFooterPath.some((path) => pathName.includes(path))
        ? (this.isShowFooter = false)
        : (this.isShowFooter = true)
    }
  }
}
</script>

<style>

.main_{
  padding-bottom: 100px !important;
}
body{
  /* background: linear-gradient(90deg, var(--topbarBg) -0.7%, #0a185100 113.23%); */
  /* background: linear-gradient(90deg, #7a7a7a -0.7%, #016cbc70 113.23%); */

    /* background-color: transparent !important; */
}

.main-content{
    margin-top: 10px !important;
}
.bg-light {
  border-radius: 4px;
        /* background-color: #f8f9fa00 !important; */
    }

.modal-backdrop {
    background-color: #ffffff00;
}
.modal-backdrop {
    --bs-backdrop-zindex: 0;
    --bs-backdrop-bg: #ffffff00;
    --bs-backdrop-opacity: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--bs-backdrop-zindex);
    width: 100vw;
    height: 100vh;
    background-color: var(--bs-backdrop-bg);
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
}

.modal {
    text-align: center;
    padding: 0 !important;
    background: rgba(0, 0, 0, .7);
    overflow-y: auto;
    /* width: auto !important; */
    /* height: auto !important; */
}
.modal {
    width: 100% !important;
    height: 100vh;
}
.fade {
    transition: opacity 0.15s linear;
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    display: none;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
}
@media (min-width: 576px) {
    .modal {
        --bs-modal-margin: 1.75rem;
        --bs-modal-box-shadow: 0 0.375rem 1.25rem 0 rgba(38, 43, 67, 0.18);
    }
}
.modal-header,.modal-body{
  background-color: #fff !important;
  .close {
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: .25em .25em;
    color: #000;
    background: transparent url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e) center / 1em auto no-repeat;
    border: 0;
    border-radius: .25rem;
    opacity: .5;
}
}

.modal-header .btn-close {
    padding: .5rem .5rem;
    margin: -.5rem -.5rem -.5rem auto;
}

[type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled), button:not(:disabled) {
    cursor: pointer;
}
.modal-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: calc(.3rem - 1px);
    border-top-right-radius: calc(.3rem - 1px);
}
/* Absolute Center Spinner */

.loading {
    position: fixed;
    z-index: 999999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

/* Transparent Overlay */

.loading:before {
    content: "";
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0.8));
    background: -webkit-radial-gradient( rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0.8));
}

/* :not(:required) hides these rules from IE9 and below */

.loading:not(:required) {
    /* hide "loading..." text */
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
}

.loading:not(:required):after {
    content: "";
    display: block;
    font-size: 10px;
    width: 1em;
    height: 1em;
    margin-top: -0.5em;
    -webkit-animation: spinner 2000ms infinite linear;
    -moz-animation: spinner 2000ms infinite linear;
    -ms-animation: spinner 2000ms infinite linear;
    -o-animation: spinner 2000ms infinite linear;
    animation: spinner 2000ms infinite linear;
    border-radius: 0.5em;
    -webkit-box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0, rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0, rgba(255, 255, 255, 0.75) 0 1.5em 0 0, rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0, rgba(255, 255, 255, 0.75) -1.5em 0 0 0, rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0, rgba(255, 255, 255, 0.75) 0 -1.5em 0 0, rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;
    box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0, rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0, rgba(255, 255, 255, 0.75) 0 1.5em 0 0, rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0, rgba(255, 255, 255, 0.75) -1.5em 0 0 0, rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0, rgba(255, 255, 255, 0.75) 0 -1.5em 0 0, rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;
}
.loading:not(:required):after {
    content: "";
    display: block;
    font-size: 10px;
    width: 1em;
    height: 1em;
    margin-top: -0.5em;
    -webkit-animation: spinner 2000ms infinite linear;
    animation: spinner 2000ms infinite linear;
    border-radius: 0.5em;
    box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0, rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0, rgba(255, 255, 255, 0.75) 0 1.5em 0 0, rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0, rgba(255, 255, 255, 0.75) -1.5em 0 0 0, rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0, rgba(255, 255, 255, 0.75) 0 -1.5em 0 0, rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@-moz-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@-o-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
label.number {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

label.number {
  display: inline-block;
  width: 50px;
  height: 50px;
  margin: 0px 5px;
  font-size: 40px;
  font-weight: 500;
  text-align: center;
  line-height: 50px;
  background-color: rgba(0, 0, 0, 0.2);
  border: solid 1px #000000;
  color: rgb(55 61 146);
  border-radius: 2px;
  background-color: rgba(229, 229, 229, 0.2);
  border: solid 1px var(--color-1-main);
  position: relative;
  vertical-align: middle;
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    display: none;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
}
.fade {
    transition: opacity 0.15s linear;
}
.modal {
    width: 100% !important;
    height: 100vh;
}
.modal {
    text-align: center;
    padding: 0 !important;
    background: rgba(0, 0, 0, .7);
    overflow-y: auto;
}
/*
.loading:before {
    content: "";
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0.8));
    background: -webkit-radial-gradient(rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0.8));
}
*, *::before, *::after {
    box-sizing: border-box;
}
.loading:not(:required) {
    font: 0 / 0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
}

.loading {
    position: fixed;
    z-index: 999999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
} */
</style>
